import { c as _c } from "react-compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { TABLE_RIGHT_TOOLBAR_WIDTH } from '../table/constants/sizes';
export const useAnimateExpandedState = t0 => {
  const $ = _c(16);
  const {
    isPinned,
    width,
    delayMs: t1
  } = t0;
  const delayMs = t1 === undefined ? 300 : t1;
  const [isHovered, setIsHovered] = useState(false);
  const [keepVisibleForCollapse, setKeepVisibleForCollapse] = useState(false);
  const pendingCollapseRef = useRef(null);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => () => {
      if (pendingCollapseRef.current !== null) {
        clearTimeout(pendingCollapseRef.current);
      }
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  const isExpanded = isPinned || isHovered;
  const visibleWidth = isExpanded ? TABLE_RIGHT_TOOLBAR_WIDTH : width;
  const contentVisible = isExpanded || keepVisibleForCollapse;
  let t4;
  if ($[2] !== isExpanded) {
    t4 = e => {
      if (e.target === e.currentTarget && !isExpanded) {
        setKeepVisibleForCollapse(false);
      }
    };
    $[2] = isExpanded;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleTransitionEnd = t4;
  let t5;
  if ($[4] !== isPinned) {
    t5 = () => {
      if (pendingCollapseRef.current !== null) {
        clearTimeout(pendingCollapseRef.current);
        pendingCollapseRef.current = null;
      }
      if (!isPinned) {
        setIsHovered(true);
      }
    };
    $[4] = isPinned;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleMouseEnter = t5;
  let t6;
  if ($[6] !== delayMs || $[7] !== isPinned) {
    t6 = () => {
      pendingCollapseRef.current = setTimeout(() => {
        if (!isPinned) {
          setKeepVisibleForCollapse(true);
        }
        setIsHovered(false);
        pendingCollapseRef.current = null;
      }, delayMs);
    };
    $[6] = delayMs;
    $[7] = isPinned;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleMouseLeave = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsHovered(true);
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const notifyWillUnpin = t7;
  let t8;
  if ($[10] !== contentVisible || $[11] !== handleMouseEnter || $[12] !== handleMouseLeave || $[13] !== handleTransitionEnd || $[14] !== visibleWidth) {
    t8 = {
      visibleWidth,
      contentVisible,
      handleTransitionEnd,
      handleMouseEnter,
      handleMouseLeave,
      notifyWillUnpin
    };
    $[10] = contentVisible;
    $[11] = handleMouseEnter;
    $[12] = handleMouseLeave;
    $[13] = handleTransitionEnd;
    $[14] = visibleWidth;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};